(function () {
  'use strict';

  var CONFIG_ID = 'mbts-product-badges-config';
  var CARD_MEDIA_SELECTOR = '.product-item__inner';
  var APPLIED_FLAG = 'mbtsBadgesApplied';

  function getBadges() {
    var el = document.getElementById(CONFIG_ID);
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function groupByPosition(badges) {
    var groups = {};
    badges.forEach(function (badge) {
      if (!badge.text) return;
      var position = badge.position || 'top_left';
      if (!groups[position]) groups[position] = [];
      groups[position].push(badge);
    });
    return groups;
  }

  function buildBadgeWrapper(position, badgesInGroup) {
    var wrapper = document.createElement('div');
    wrapper.className = 'mbts-custom-badge mbts-custom-badge--' + position;
    badgesInGroup.forEach(function (badge) {
      var pill = document.createElement('span');
      pill.className = 'mbts-custom-badge-pill';
      pill.style.color = badge.textColor || '#ffffff';
      pill.style.background = badge.backgroundColor || '#c49a78';
      pill.textContent = badge.text;
      wrapper.appendChild(pill);
    });
    return wrapper;
  }

  function applyBadges(groups) {
    var positions = Object.keys(groups);
    if (positions.length === 0) return;

    var cards = document.querySelectorAll(CARD_MEDIA_SELECTOR);
    cards.forEach(function (card) {
      if (card.dataset[APPLIED_FLAG]) return;
      if (card.dataset.isTravelSystem !== 'true') return;
      card.dataset[APPLIED_FLAG] = 'true';
      positions.forEach(function (position) {
        card.appendChild(buildBadgeWrapper(position, groups[position]));
      });
    });
  }

  function init() {
    var badges = getBadges();
    if (badges.length === 0) return;
    var groups = groupByPosition(badges);

    applyBadges(groups);

    var observer = new MutationObserver(function () {
      applyBadges(groups);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
